import { Injectable } from '@angular/core';

import {
    HttpInterceptor,
    HttpRequest,
    HttpResponse,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators'
import { MessageService } from '../services/message.service';
import { AlertType } from '../enumerators/messages.enum';
import { ResponseStatusType, ResponseStatusMessageType } from '../enumerators/enumerators.enum';

@Injectable()
export class HttpErrorHandlingInterceptor implements HttpInterceptor {

    constructor(private mensajeService: MessageService) { }

    /**
     * The intercept function checks if the user is online, displays an error message if not, and
     * handles the HTTP response status and message.
     * @param request - The `request` parameter is an instance of the `HttpRequest` class, which
     * represents an HTTP request made by the client.
     * @param {HttpHandler} next - The `next` parameter is an instance of the `HttpHandler` class. It
     * represents the next handler in the chain of handlers that will be called to process the request.
     * @returns an Observable of type HttpEvent<any>.
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!window.navigator.onLine) {
            this.mensajeService.alert(AlertType.Error, 'Se ha perdido la conexión a internet');
            return throwError("Se ha perdido la conexión a internet");
        }
        return next.handle(request).pipe(

            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    var response = this.handlingHttpStatus(event.status, event.body?.message);
                    if (response) { this.mensajeService.alert(response.alerta, response.message) };
                }

                return event;
            }));
    }

    private handleError(error: HttpErrorResponse) {
        if (error.status === 0 && error.error instanceof ProgressEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            // console.log('Client side error:', error.error)
        }
    };

   /**
    * The function handles different HTTP status codes and returns an object with an alert type and a
    * corresponding message.
    * @param {number} status - The `status` parameter is a number that represents the HTTP status code
    * of a response. It is used to determine the appropriate action or message to be returned based on
    * the status code.
    * @param {string} message - The `message` parameter is a string that represents an optional custom
    * message to be displayed along with the status code.
    * @returns an object with two properties: "alerta" and "message". The values of these properties
    * depend on the input status parameter. If the status matches one of the predefined constants (e.g.
    * ResponseStatusType.NO_CONTENT), then the corresponding alert type and message are returned. If
    * the status does not match any of the predefined constants, null is returned.
    */
    handlingHttpStatus(status: number, message: string) {
        switch (status) {
            case ResponseStatusType.NO_CONTENT:
                return { alerta: AlertType.Information, message: ResponseStatusMessageType.NO_CONTENT }
            case ResponseStatusType.PARTIAL_CONTENT:
                return { alerta: AlertType.Warning, message: message ? message : ResponseStatusMessageType.PARTIAL_CONTENT }
            case ResponseStatusType.BAD_REQUEST:
                return { alerta: AlertType.Error, message: message ? message : ResponseStatusMessageType.BAD_REQUEST }
            case ResponseStatusType.UNAUTHORIZED:
                return { alerta: AlertType.Warning, message: ResponseStatusMessageType.UNAUTHORIZED }
            case ResponseStatusType.PARTIAL_CONTENT:
                return { alerta: AlertType.Information, message: ResponseStatusMessageType.NOT_FOUND }
            case ResponseStatusType.INTERNAL_SERVER_ERROR:
                return { alerta: AlertType.Error, message: ResponseStatusMessageType.INTERNAL_SERVER_ERROR }
            default:
                return null
        }
    }
}